import { useSelector } from 'react-redux';
import {
  selectSWOTData,
} from 'Selector/CompaniesSelector';
import styled from 'styled-components';
import {
  boxShadow, maxWidth, primaryColor, primaryFont,
  primaryHeadingColor, retina, secondaryFont,
} from 'Utils/utilsStyle';
import BulletListItem from './BulletListItem';
import SwotAnalysis from './SwotAnalysis';

const Wrapper = styled.div`
  .swot-wrapper {
    background-color: rgb(255, 255, 255);
    border-radius: 16px;
    padding: 24px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      border-radius: 12px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
  .view-points-btn {
    background-color: ${primaryColor};
    display: inline-block;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    padding: 6px 10px;
    font-family: ${primaryFont};
    margin-left: 10px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
      padding: 5px 8px;
      height: 27px;
    }
  }
  .pain-points-layer {
    padding: 24px 33px 19px 7px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: ${boxShadow};
    margin: 20px 0;
    .pain-points-head {
      font-family: ${secondaryFont};
      color: ${primaryHeadingColor};
      padding-left: 25px;
      font-size: 25px;
      letter-spacing: -0.7px;
    }
  }
`;

const SwotTab = function SwotTab() {
  const swotData = useSelector(selectSWOTData);
  const { painPoints } = swotData;

  return (
    <Wrapper>
      <div className="swot-wrapper company-swot-section">
        <SwotAnalysis
          isSwotTab
        />
      </div>
      <div className="pain-points-layer" id="PainPoints">
        <h6 className="pain-points-head">Pain Points</h6>
        {painPoints?.map((p) => (
          <BulletListItem
            listHeading={p.heading}
            listDescription={p.description}
            swatTabFlag
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default SwotTab;
